<template>
  <div class="flex items-center gap-x-2 overflow-hidden">
    <button
      @click="emit('cancel')"
      :disabled="submitting"
      class="border-2 border-blue-600 text-blue-600 px-3 rounded-md h-[42px] font-semibold text-sm"
    >
      <span class="hidden md:block">Cancel</span>
      <span class="md:hidden"><XMarkIcon class="w-5 h-5" /></span>
    </button>
    <button
      @click="emit('submit')"
      :disabled="disabled"
      class="btn btn-primary h-[42px] overflow-hidden font-semibold text-sm flex items-center gap-x-2"
    >
      <span class="truncate">
        {{ label }}
      </span>
      <Spinner
        v-if="submitting"
        class="text-gray-100 shrink-0"
      />
    </button>
  </div>
</template>

<script setup>
import Spinner from '@/Components/Icons/Spinner.vue'
import { XMarkIcon } from '@heroicons-2/vue/24/outline'
const emit = defineEmits(['cancel', 'submit'])

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    required: true
  },
  submitting: {
    type: Boolean,
    required: true
  }
})
</script>
